import api from '@/api'

const fetchHiddenNews = () => {
  return JSON.parse(localStorage.getItem('hiddenNews') || '[]')
};

export default {
  state: {
    locks: 0,
    isAuthorized: false,
    session: {
      userId: undefined,
      organizationId: undefined
    },
    hiddenNews: fetchHiddenNews()
  },

  getters: {
    isAuthorized: s => s.isAuthorized,
    hiddenNews: s => s.hiddenNews
  },

  mutations: {
    saveToken(s, token) {
      api.defaults.headers.common['Authorization'] = token;
      localStorage.setItem('token', token);
    },

    setLoggedIn(s) {
      s.isAuthorized = true;
    },
    setLoggedOut(s) {
      s.isAuthorized = false;

      delete api.defaults.headers.common['Authorization'];
      localStorage.removeItem('token');
      localStorage.removeItem('hiddenNews');
    },
    setReady(s) {
      // if (s.locks === Infinity) {
      //   s.locks = 0;
      // }
    },
    lockScreen(s) {
      ++s.locks;
    },
    unlockScreen(s) {
      --s.locks;
    },

    setHiddenNews(s, {id, until}) {
      if (!_.find(s.hiddenNews, { id })) {
        s.hiddenNews.push({id, until});
        localStorage.setItem('hiddenNews', JSON.stringify(s.hiddenNews));
      }
    }
  },
  actions: {
    async isSessionValid({commit, dispatch}) {
      if (this.state.auth.isAuthorized) {
        return true;
      }

      const token = localStorage.getItem('token');
      if (typeof token !== 'string') {
        return false
      }

      let valid = false;

      try {
        api.defaults.headers.common['Authorization'] = token;

        const response = await api.post('/account/auth');
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          valid = true;

          commit('saveToken', token);

          await dispatch('handleProfile', {
            currentUser: true,
            profile: result
          });

          commit('setLoggedIn');

          await dispatch('fetchFileExtensions');
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while checking authorization token', e);
      }

      if (!valid) {
        dispatch('logout');
      }

      return valid;
    },

    async logout({commit, dispatch}) {
      commit('setLoggedOut');
      dispatch('clearAccount');
      window.location.href = '/';
    },

    async login({commit, dispatch}, {login, password}) {
      try {
        const response = await api.post('/account/login', { login, password });
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          commit('saveToken', 'Bearer ' + result.accessToken);

          await dispatch('handleProfile', {
            currentUser: true,
            profile: result
          });

          commit('setLoggedIn');

          await dispatch('fetchFileExtensions');
          await dispatch('fetchGlobalSettings');
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while logging user in', e);
        throw e;
      }
    },

    async register({commit}, {email, phone, password, firstName, lastName, middleName, passportSerial, passportNum, inviteCode}) {
      try {
        const response = await api.post('/account/register', {email, phone, password, firstName, lastName, middleName, passportSerial, passportNum, inviteCode});
        const { status, result, errorCode  } = response.data;

        if (status === 200) {
          return {
            userId: result.id,
            eventId: result.eventId
          }
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while registering new user', e);

        if (!e instanceof api.Errors) {
          throw api.Errors.UNKNOWN;
        }
        else throw e;
      }
    },

    async confirmPhoneByEventId({dispatch, getters}, {eventId, code}) {
      let error;

      try {
        const response = await api.post(`/account/confirm/${eventId}`, { code });
        const { status, errorCode }  = response.data;

        if (status === 200) {
          try {
            await dispatch('fetchUser', {userId: getters.currentUser.id});
          }
          catch(e) {
            console.error('unable to fetch user profile after phone number was confirmed');
          }

          return true;
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error(e);
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async resendCodeByEventId({}, {eventId}) {
      try {
        const response = await api.post(`/account/confirm/${eventId}/resend`);
        const { status, result, errorCode } = response.data;

        if (status !== 200) {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error(e);
        throw e;
      }
    },

    async confirmEmail({commit, dispatch}, {code, confirmId}) {
      let error;

      try {
        const response = await api.post(`/account/confirm/email/${confirmId}`, {
          code: code,
          login: true
        });
        const { status, result, errorCode  } = response.data;

        if (status === 200) {
          commit('saveToken', 'Bearer ' + result.accessToken);

          await dispatch('handleProfile', {
            currentUser: true,
            profile: result
          });

          commit('setLoggedIn');
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    hideActiveNews({commit}, {id, until}) {
      commit('setHiddenNews', {id, until});
    },

    hideTodayNews({commit}) {
      commit('setHiddenNews', {id, until});
    }
  }
}
